import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid, TextField, InputAdornment } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import "../Preventive Maintenance/PreventiveMaintenance.css";
import { useNavigate } from 'react-router-dom';
import CustomBreadcrumbs from '../Breadcrumb';
import { useDispatch, useSelector } from 'react-redux';
import { getVendorData } from '../../ReduxStore/VendorDataSlice';
import { convertUTCtoIST } from '../../helpers/DateConvert';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';

const AssetDeclarationVendorList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
    ];


    const [searchInput, setSearchInput] = useState('');


    const { response, loading } = useSelector(state => state.vendor);

    const filteredAssets = response && response.filter((item) => {
        const searchString = searchInput.toLowerCase();
        return (
            item.vendor_address.toLowerCase().includes(searchString) ||
            item.vendor.toLowerCase().includes(searchString)
        );
    });

    useEffect(() => {
        dispatch(getVendorData());
    }, [])




    const handleSupplierSelection = async (item) => {
        navigate(`/asset-declaration-history/${item.vendor}`)


    }

    const searchInputHandler = (e) => {
        setSearchInput(e.target.value);
    };


    return (
        <Layout>
            <Container>
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Supplier List" />
                </Box>
                <Box mb={2}>
                    <Grid container className='row1'>
                        <Grid item xs={5}>
                            <Typography variant="body1" style={{ fontSize: '24px', fontWeight: 300 }}>
                                Supplier List for PLI Asset Declaration
                            </Typography>
                        </Grid>
                        <Grid item xs={3} className='row1'>
                            <TextField
                                placeholder="Search Supplier"
                                variant="outlined"
                                size="small"
                                onChange={searchInputHandler}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                    </Grid>
                </Box>
                {loading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh" >
                        <GridLoadingSpinner />
                    </Box>
                ) : (
                    filteredAssets && filteredAssets.map((item, index) => (
                        <Grid container className="assets" key={index} onClick={() => { handleSupplierSelection(item) }}>
                            <Grid item xs={12} sm={5}>
                                <h4>Supplier Name: {item.vendor_group}</h4>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <h4>Vendor Code: {item.vendor}</h4>
                            </Grid>
                            {/* <Grid item xs={12} sm={3}>
                                <h4>Vendor Location: {item.location}</h4>
                            </Grid> */}
                            <Grid item xs={12} sm={3}>
                                <h4>PLI Asset Declaration: {item?.declrtn_submit_last_date ? convertUTCtoIST(item.declrtn_submit_last_date) : "NA"}</h4>
                            </Grid>

                        </Grid>

                    )

                    ))}
            </Container>
        </Layout>
    );
};

export default AssetDeclarationVendorList;
